"use strict";
function getArrowIcon() {
  return `
    <svg width="25px" height="25px" viewBox="-3 -3 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z" fill="var(--primary)"></path>
    </svg>
  `;
}
export default getArrowIcon;
